import styled from 'styled-components/macro'

const ContentWrapper = styled.div`
  flex: 1;
  margin-left: 40px;
  max-width: 1024px;
`

export default ContentWrapper